import { Badge } from "../../../components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../components/ui/tooltip";
import { cn } from "../../../lib/utils";
import { BloqueioInfo, LastStage } from "../types";

const LABELS: Record<LastStage, string> = {
  arquivos_prontos: "Arquivos prontos",
  enviada_wts: "Enviada (WTS)",
  aceite: "Aceite",
  liquidado: "Liquidado",
  comprado: "Comprado",
  baixado: "Baixado",
  nao_enviada: "Não enviada",
  bloqueado: "Bloqueado",
  franquia_pausada: "Franquia pausada",
};

const CLASSES: Record<LastStage, string> = {
  arquivos_prontos: "bg-slate-100 text-slate-700",
  enviada_wts: "bg-blue-100 text-blue-700",
  aceite: "bg-indigo-100 text-indigo-700",
  liquidado: "bg-amber-100 text-amber-700",
  comprado: "bg-violet-100 text-violet-700",
  baixado: "bg-emerald-100 text-emerald-700",
  nao_enviada: "bg-red-100 text-red-700",
  bloqueado: "bg-red-600 text-white",
  franquia_pausada: "bg-orange-100 text-orange-800",
};

export function LastStageBadge({ stage, bloqueio }: { stage: LastStage; bloqueio?: BloqueioInfo | null }) {
  const badge = (
    <Badge variant="outline" className={cn("border-transparent", CLASSES[stage])}>
      {LABELS[stage]}
      {bloqueio && ` · ${bloqueio.origem === "gestor" ? "Gestor" : "Cliente"}`}
    </Badge>
  );
  if (!bloqueio) return badge;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="cursor-help">{badge}</span>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs">
        <BloqueioDescricao bloqueio={bloqueio} />
      </TooltipContent>
    </Tooltip>
  );
}

export function BloqueioDescricao({ bloqueio }: { bloqueio: BloqueioInfo }) {
  const quando = new Date(bloqueio.criadoEm).toLocaleString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    dateStyle: "short",
    timeStyle: "short",
  });
  const motivo = [bloqueio.motivoCodigo, bloqueio.motivoTexto].filter(Boolean).join(" — ") || "sem motivo";
  return (
    <span>
      {bloqueio.escopo === "telefone" ? "Telefone desativado" : "Bloqueado"} pelo {bloqueio.origem} na ops{" "}
      {bloqueio.ops}: {motivo}. {bloqueio.criadoPor} em {quando}.
    </span>
  );
}
